import { useState } from "react";
import { Modal, Table, Tag, Button } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import trans from "../../../utils";
import { formatDateString } from "../../../JsHelpers/DateFormat";
import { useGetServiceRequestTasksQuery } from "../../../Redux/service/Dispatcher/Dispatcher";
import { TaskPopup } from "../../Tasks/Popups/TaskPopup";

const TASK_STATUS_COLORS = {
  todo: "default",
  delayed: "orange",
  inProgress: "blue",
  done: "green",
  overDue: "red",
  cancelled: "red",
};

export default function ShowTasksModal({ open, requestId, onClose }) {
  const { data, isFetching } = useGetServiceRequestTasksQuery(requestId, {
    skip: !open || !requestId,
  });
  const [viewTaskId, setViewTaskId] = useState(null);

  const columns = [
    { title: trans("Task Code"), dataIndex: "code", key: "code", width: 130 },
    { title: trans("Name"), dataIndex: "name", key: "name", width: 200, ellipsis: true },
    {
      title: trans("Status"),
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (status) => (
        <Tag color={TASK_STATUS_COLORS[status] || "default"} className="text-capitalize">
          {trans(status)}
        </Tag>
      ),
    },
    {
      title: trans("Assigned To"),
      key: "assignedTo",
      width: 150,
      render: (_, record) => record.assignedTo?.name || trans("Unassigned"),
    },
    {
      title: trans("Start Time"),
      dataIndex: "startTime",
      key: "startTime",
      width: 170,
      render: (v) => (v ? formatDateString(v) : "-"),
    },
    {
      title: trans("Estimated Duration"),
      dataIndex: "expectedDuration",
      key: "expectedDuration",
      width: 140,
      render: (v) => (v != null ? `${v} ${trans("Min")}` : "-"),
    },
    {
      title: trans("Completion Time"),
      dataIndex: "completionTime",
      key: "completionTime",
      width: 170,
      render: (v) => (v ? formatDateString(v) : "-"),
    },
    {
      title: trans("Actions"),
      key: "actions",
      width: 90,
      render: (_, record) => (
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={() => setViewTaskId(record.id)}
        >
          {trans("View")}
        </Button>
      ),
    },
  ];

  return (
    <Modal
      title={trans("Show Tasks")}
      open={open}
      onCancel={onClose}
      footer={null}
      width={1000}
    >
      <Table
        rowKey="id"
        columns={columns}
        dataSource={data?.data || []}
        loading={isFetching}
        pagination={false}
        scroll={{ x: "max-content" }}
      />
      <TaskPopup
        taskId={viewTaskId}
        onClose={() => setViewTaskId(null)}
        zIndex={1200}
      />
    </Modal>
  );
}
